import { Component, OnInit, OnDestroy, ViewChild, ElementRef, Output, EventEmitter, ComponentFactoryResolver } from '@angular/core';
// import { saveAs } from 'file-saver';
import { ApiService } from '../services/api.service';
import { KeyContents } from '../services/keycontents.service';
import { IPublicProjectBoard, IProjectBoard, IPostit, ISpace, IPostitComment, IPostitLike, IProjectBoardMember } from '../interfaces';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { LocalStorageService } from '../services/localstorage.service';
import { SharedService } from '../services/shared.service';
import { NgForm } from '@angular/forms';
import { fromEvent } from 'rxjs/observable/fromEvent';
import { interval } from 'rxjs/observable/interval';
import { throttle } from 'rxjs/operators';
import { Communities } from '../services/communities.service';

@Component({
  selector: 'app-board',
  templateUrl: './board.component.html',
  styleUrls: ['./board.component.scss'],
  providers: [ApiService],
})

export class BoardComponent implements OnInit, OnDestroy {

  @ViewChild('spaceListener') spaceListener: ElementRef;
  @ViewChild('postitText') postitText: ElementRef;
  @ViewChild('postit') postit: ElementRef;
  @ViewChild('msgBox') msgBox: ElementRef;

  boardId: number;
  projectBoardId: number;
  projectBoard: IProjectBoard | IPublicProjectBoard = {
    project: 0,
  };

  lang: string = 'fr';

  isPublic: boolean = false;

  sendingPostIt: boolean = false;

  flapToggled: boolean = false;
  editMode: boolean = false;
  inviteMode: boolean = false;
  fsMode: boolean = false;
  fsOnly: boolean = false;
  editingPostit: boolean = false;
  userIsPostitAuthor: boolean = false;
  userIsProjectBoardAuthor: boolean = false;
  showPostitChoice: boolean = false;
  showZenbaiaChoice: boolean = false;
  showProjectBoardChoice: boolean = false;
  showCommentChoice: boolean = false;
  showLeaveProjectBoardChoice: boolean = false;
  zeebraSharing: boolean = false;
  shownMsg: boolean = false;
  errors: any = {
    name: '',
    project: ''
  };
  zenbaiaContent: string = '';
  zenbaiaLoading: boolean = false;
  zenbaiaAccess: boolean = false;

  mouseDown: boolean = false;
  hasMoved: boolean = false;
  lastEvent: MouseEvent;

  isNewProjectBoard: boolean = false;
  isExistingProject: boolean = false;


  modelName: String = '';
  modelDesc: String = '';
  modelCategory: Object = {};
  postits: Array<IPostit> = [];
  halfPostit: number = 60;
  spaces: Array<ISpace> = [];
  spaceBoundings: any;
  currentPostit: IPostit = {};
  currentElem: any;
  postitComments: Array<IPostitComment> = [];
  postitCommentsNames: Array<string> = [];
  postitLikes: Array<IPostitLike> = [];
  postitLiked: IPostitLike = {};
  isPostitLiked: boolean = false;
  collabs: Array<IProjectBoardMember> = [];
  members: Array<IProjectBoardMember> = [];
  currentPostitAuthor: any = {};
  user: any;
  newComment: IPostitComment = {};
  currentComment: IPostitComment = {};
  newLike: IPostitLike = {};
  sendingFile: boolean = false;
  postitBaseContent: string = '';

  fileName: string;
  file: File;
  postitCleared: boolean = false;

  community: any = '';
  categories: Array<any> = [];
  labels: Array<any> = [];

  canvas: any;
  enableFS: boolean = false;

  breakTimeout: boolean = false

  openedPostit: any;

  zoomLevel: number = 100;
  zoomLevelMax: number = 200;
  zoomLevelMin: number = 100;
  scale: number = 1;

  isEditingPostit = false;
  isCommentEditing = false;
  isResizing = false;
  resizeFromLeft = false;
  isMoving = false;
  refWidth;
  refHeight;

  canCloseEdit = true;
  loading = false;
  private contentSubscription: any;
  private contents_dict: any = {};

  constructor(
    private route: ActivatedRoute,
    private _api: ApiService,
    private _router: Router,
    private communities_service: Communities,
    private _storage: LocalStorageService,
    private _sharedService: SharedService,
    private contents_service: KeyContents,
  ) { }

  //////////////////
  // Initializing //
  //////////////////

  ngOnInit() {
    this.activateTimeout();
    this.mouseHandlerInit();
    this.dragHandlerInit();
    this.user = this._storage.getObject('user');
    this.getSpaceBoundings();
    this.getParams();
    if (this.isPublic) {
      return
    }
    this.lang = this.communities_service.getLanguage(this._storage.get('community_id'));
    console.log('board init', this.isNewProjectBoard, this.projectBoardId)
    this.stratboxCanAccessZenbaia();
    if (!this.isNewProjectBoard) {
      this.getMembers();
    }
    this._sharedService.changeEmitted$
      .subscribe(data => {
        if (data.hasOwnProperty('fullscreen')) {
          this.fsMode = data.fullscreen;
        }
      });
    this.refWidth = document.getElementsByClassName('js-zoom')[0].getBoundingClientRect().width
    this.refHeight = document.getElementsByClassName('js-zoom')[0].getBoundingClientRect().height

    this.contentSubscription = this.contents_service.contents.subscribe((el) => {
      this.contents_dict = el;
    })
    this.contents_service.getContents();
    this.postitBaseContent = this.getValue('stratbox:new_postit_content')
  }

  ngOnDestroy() {
    this.deactivateTimeout()
    this.contentSubscription.unsubscribe();
  }

  getValue(key) {
    const value_lang = `value_${this.lang}`
    return this.contents_dict.hasOwnProperty(key) ? this.contents_dict[key][value_lang] : "";
  }

  getSpaceBoundings() {
    this.spaceBoundings = this.spaceListener.nativeElement.getBoundingClientRect();
  }

  onFileSelected(event) {
    if (event.target.files.length > 0) {
      this.fileName = event.target.files[0].name;
      this.file = event.target.files[0]
    }
  }

  removeFile() {
    this.fileName = null;
    this.file = null;
    (<HTMLInputElement>document.getElementById("file")).value = null;
  }

  getParams() {
    this.route
      .params
      .subscribe(
        (params: Params) => {
          if (params.id) {
            this.projectBoardId = params.id;
            // this._sharedService.emitChange({enableFS:true});
            this.getProjectBoard();
          } else if (params.project_board_id) {
            this.projectBoardId = params.project_board_id;
            this.toggleFS();
            this.fsOnly = true;
            this.getProjectBoard();
          } else if (params.project_board_uuid) {
            this.projectBoardId = params.project_board_uuid;
            this.toggleFS();
            this.fsOnly = true;
            this.getPublicProjectBoard();
          } else {
            this.projectBoardId = params.board_id;
            this.isNewProjectBoard = true;
            this.boardId = params.board_id;
            this.getBoardPreview();
            this.toggleEditMode();
          }
        });
  }

  getBoardPreview() {
    this._api.boardPreview
      .retrieve(this.boardId)
      .subscribe(
        (p) => {
          console.log(p)
          this.isExistingProject = true;
          this.spaces = p.spaces_obj;
          this.modelName = p.name;
          this.modelDesc = p.description;
          this.modelCategory = p.category_obj;
        },
        (err) => { console.log(err) });
  }

  getMembers() {
    this._api.members
      .list()
      .subscribe(
        (data) => {
          console.log(data)
          let members = data.results;
          this.getCollabs(members);
        },
        (err) => { console.log(err) });
  }

  getCollabs(members: Array<any>) {
    this._api.projectBoardMembers
      .list({
        project_board: this.projectBoardId,
        limit: 150,
      })
      .subscribe(
        (data) => {
          let collabs: Array<IProjectBoardMember> = [];
          let collabsIds: Array<number> = [];
          let newMembers: Array<any> = [];

          data.results.map((c, i) => {
            if (c.user != this.projectBoard.author) {
              collabsIds.push(c.user);
              collabs.push(c);
            }
          });

          members.map((m, i) => {
            // console.log(m)
            if (!collabsIds.includes(m.user) && (m.user != this.projectBoard.author)) {
              newMembers.push(m);
            }
          });

          this.collabs = collabs;
          this.members = newMembers;
        },
        (err) => { console.log(err) });
  }

  inviteMember(m) {
    let member: IProjectBoardMember = {};
    console.log(m)
    member.project_board = this.projectBoardId;
    member.user = m.id;

    this._api.projectBoardMembers
      .create(member)
      .subscribe(
        (data) => {
          this.getMembers();
          const msg = this.getValue("stratbox:success-add-member");
          this.showMsg(`${m.full_name} ${msg}`);
        },
        (err) => { console.log(err); }
      )
  }

  rejectMember(c: IProjectBoardMember) {
    this._api.projectBoardMembers
      .destroy(c.user)
      .subscribe(
        (data) => {
          this.getMembers();
          const msg = this.getValue("stratbox:success-delete-member");
          this.showMsg(`${c.author_obj.full_name} ${msg}`);
        },
        (err) => { console.log(err); }
      )
  }

  leaveProjectBoard() {
    let user = this.collabs.filter((c) => {
      if (c.user === this.user.id) {
        return c;
      }
    })
    this._api.projectBoardMembers
      .destroy(user[0].id, user[0])
      .subscribe(
        (data) => {
          this._router.navigate(['/boards'])
        },
        (err) => { console.log(err); }
      )
  }

  showLeaveProjectBoard() {
    this.showLeaveProjectBoardChoice = true;
  }

  hideLeaveProjectBoard() {
    this.showLeaveProjectBoardChoice = false;
  }


  ////////////////////
  // Edit Or Create //
  ////////////////////

  initFormData() {
    const community_id = this._storage.get('community_id');
    let formData = new FormData();
    if (this.file) {
      formData.append("file", this.file);
    } else {
      formData.append("file", "");
    }
    if (this.projectBoard.name) {
      formData.append("name", this.projectBoard.name);
    }
    if (this.projectBoard.description) {
      formData.append("description", this.projectBoard.description);
    }
    if (this.projectBoard.project) {
      formData.append("project", this.projectBoard.project.toString());
    }
    formData.append("community", community_id)
    formData.append("community_id", community_id)
    if (this.boardId) {
      formData.append("board", this.boardId.toString());
    }
    return formData
  }
  createProjectBoard() {
    this.errors = {
      name: '',
      project: ''
    }

    this._api.projectBoards
      .create(this.initFormData(), {}, true)
      .subscribe(
        (data) => {
          this._router.navigate(['/board', data.id]);
        },
        (err) => {
          this.errors = err;
        })
  }

  editProjectBoard() {
    this._api.projectBoards
      .partialUpdate(this.projectBoardId, this.initFormData(), {}, true)
      .subscribe(
        (data: IProjectBoard) => {
          this.projectBoard = data;
          this.toggleEditMode();
        }, (err) => { console.log(err); })
  }

  checkProjectStatus() {
    if (this.isNewProjectBoard) {
      this.createProjectBoard();
    } else {
      this.editProjectBoard();
    }
  }

  editOrCreate() {
    this.checkProjectStatus();
  }


  //////////////////
  // ProjectBoard //
  //////////////////

  getProjectBoard() {
    this._api.projectBoards
      .retrieve(this.projectBoardId, { community: this._storage.get('community_id') })
      .subscribe(
        (p: IProjectBoard) => {
          this.projectBoard = p;
          this.isExistingProject = true;
          this.spaces = this.projectBoard.board_obj.spaces_obj;
          this.fileName = this.projectBoard.file_name;
          this.getPostits();
          this.autoUpdate();
          if (this.user.id == this.projectBoard.author) {
            this.userIsProjectBoardAuthor = true;
          }
        },
        (err) => { console.log(err) });
  }

  getPublicProjectBoard() {
    this.isPublic = true;
    this._api.publicProjectBoards
      .retrieve(this.projectBoardId, { community: this._storage.get('community_id') })
      .subscribe(
        (p: IPublicProjectBoard) => {
          this.projectBoard = p;
          this.isExistingProject = true;
          this.spaces = this.projectBoard.board.spaces;
          this.fileName = this.projectBoard.file_name;
          this.postits = this.projectBoard.postits;
        },
        (err) => { console.log(err) });
  }

  deleteProjectBoard() {
    const board = this.projectBoard;
    console.info(board)
    this._api.projectBoards
      .destroy(this.projectBoardId)
      .subscribe(
        (data) => {
          this._router.navigate(['/']);
        }, (err) => { console.log(err); }
      )
  }

  hideDeleteProjectBoard() {
    this.showProjectBoardChoice = false;
  }

  showDeleteProjectBoard() {
    this.showProjectBoardChoice = true;
  }


  autoUpdate() {
    let interval = setInterval(() => {
      if (!this.breakTimeout && !this.isEditingPostit) {
        this.getPostits()
      }
    }, 5000)
  }

  getPostits() {
    this._api.postits
      .list({
        project_board: this.projectBoardId,
        limit: 150,
      })
      .subscribe(
        (data) => {
          if (!this.breakTimeout) {
            this.postits = this.attachAuthorInfo(data.results);
          }
        },
        (err) => { console.log(err) });
    this.canCloseEdit = true;
  }

  changeColor(postit, color) {
    this.getPostitAuthor()
    setTimeout(() => {
      this.currentPostit.color = color;
      this.saveContent();
    }, 300)
  }

  activateTimeout() {
    console.log('activated');
    this.breakTimeout = false;
  }
  deactivateTimeout() {
    console.log('deactiavted');
    this.breakTimeout = true;
  }

  removeToolbar() {
    this.activateTimeout()
    let elems = document.getElementsByClassName('toolbar-opened')
    this.isPostitLiked = false;
    Array.from(elems).forEach(function (item) {
      let htmlItem = item as HTMLElement;
      htmlItem.style.zIndex = 'initial';
      htmlItem.classList.remove('toolbar-opened', 'color-toolbar-opened', 'toolbar-inverted')
    })
  }



  ////////////////////
  // Postit Edition //
  ////////////////////

  showMsg(message: string, time: number = 2500) {
    this.msgBox.nativeElement.innerText = message;
    this.shownMsg = true;

    let that = this;
    let timeout = setTimeout(() => {
      that.shownMsg = false;
      clearTimeout(timeout);
    }, time);
  }

  updatePostit() {
    this._api.postits
      .partialUpdate(this.currentPostit.id, {
        color: this.currentPostit.color,
        details: this.currentPostit.details,
        content: this.currentPostit.content,
        left: this.currentPostit.left,
        top: this.currentPostit.top,
        width: this.currentPostit.width
      })
      .subscribe(
        (data: IPostit) => {
        }, (err) => {
          this.showMsg(err.content);
        }
      )
  }

  updateDetail() {
    this._api.postits
      .partialUpdate(this.currentPostit.id, {
        details: this.currentPostit.details,
      })
      .subscribe(
        (data: IPostit) => {
        }, (err) => {
          this.showMsg(err.detail);
          this.getPostits();
        }
      )
  }

  createPostit() {
    this.getSpaceBoundings();

    let newPostit: IPostit = {
      left: 0,
      top: 0,
      color: 2,
      content: this.postitBaseContent,
      project_board: this.projectBoardId
    };

    let board = document.getElementsByClassName('board')[0];
    let boardRect = board.getBoundingClientRect()

    newPostit.top = boardRect.top + document.documentElement.scrollTop + (boardRect.height / 2)   // en px
    newPostit.left = boardRect.left + document.documentElement.scrollLeft + (boardRect.width / 2) // en px

    newPostit.top = (newPostit.top / boardRect.height) * 100  // en %
    newPostit.left = (newPostit.left / boardRect.width) * 100 // en %

    this._api.postits
      .create(newPostit)
      .subscribe(
        (data: IPostit) => {
          let p = {
            ...data,
            writtenByMe: true
          }
          this.postits.push(p);
          setTimeout(() => {
            let postits = Array.prototype.slice.call(document.getElementsByClassName('postit')) //HTMLCollection to Array
            let htmlTarget = postits.find((el) => el.id == data.id)
            let iconTarget = htmlTarget.getElementsByClassName('postit-toolbar')[0].getElementsByClassName('icon-detail')[0]
            this.currentPostit = p;
            let click = new CustomEvent("click", {  // simulate click on element with data attached to it
              "detail": p
            });

            iconTarget.dispatchEvent(click);
          }, 200);
        },
        (err) => { console.log(err); }
      )
  }

  editPostit(event: MouseEvent) {
    this.isEditingPostit = true;
    event.stopPropagation();
    this.removeToolbar()
    this.createListeners();

    this.newComment = {};
    this.getPostitAuthor();
    this.openEdition();
    this.getPostitComments();
    this.getPostitLikes();

    if (this.currentPostit.writtenByMe) {
      setTimeout(() => {
        let editionModal = document.getElementsByClassName('edit-post')[0] as HTMLElement;
        let postit = editionModal.getElementsByClassName("postit")[0] as HTMLElement;
        let textarea = postit.getElementsByClassName("textarea")[0] as HTMLElement;
        console.log(textarea)
        textarea.dispatchEvent(new Event('input'));
      }, 200)
    }

    this.hasMoved = false;
  }

  createListeners() {
    // listeners which trigger autosave when user finishes title or description completion
    var timer1 = null;
    var timer2 = null;
    setTimeout(() => {
      let descriptionTextarea = document.getElementsByClassName('edit-post')[0].getElementsByClassName('description')[0] as HTMLElement;
      descriptionTextarea.addEventListener('keydown', (e) => {
        this.canCloseEdit = false;
        clearTimeout(timer1);
        timer1 = setTimeout(() => {
          this.saveContent()
          this.canCloseEdit = true;
        }, 700)
      });

      let titleTextarea = document.getElementsByClassName('edit-post')[0].getElementsByClassName('postit')[0] as HTMLElement;
      titleTextarea.addEventListener('keydown', (e) => {
        this.canCloseEdit = false;
        clearTimeout(timer2);
        timer2 = setTimeout(() => {
          this.saveContent()
          this.canCloseEdit = true
        }, 700)
      });
    }, 500)
  }

  editPostitWritingMode(event: MouseEvent) {
    this.editPostit(event)
    setTimeout(() => {
      let input = document.getElementsByClassName('answer-bar')[0] as HTMLElement;
      let textarea = input.getElementsByClassName("input")[0] as HTMLElement;
      textarea.focus();
    }, 500)
  }

  openEdition() {
    this.editingPostit = true;
  }

  getPostitAuthor() {
    console.log('this.currentPostit.author_obj.id', this.currentPostit, this.user)
    this.currentPostitAuthor = this.currentPostit.author_obj;
    this.userIsPostitAuthor = this.user.id == this.currentPostit.author ? true : false;
    console.log('this.userIsPostitAuthor', this.userIsPostitAuthor)
    // this._api.members
    //   .retrieve(this.currentPostit.author_obj.id)
    //   .subscribe(
    //     (data) => {
    //       this.currentPostitAuthor = data;
    //       console.log('this.currentPostitAuthor', this.currentPostitAuthor)
    //       if (this.user == this.currentPostitAuthor.author) {
    //         this.userIsPostitAuthor = true;
    //       } else {
    //         this.userIsPostitAuthor = false;
    //       }
    //     },
    //     (err) => { console.log(err) });
  }

  deletePostit() {
    let postits = Array.prototype.slice.call(document.getElementsByClassName('postit')) //HTMLCollection to Array
    let target = postits.find((el) => el.id == this.currentPostit.id)
    this._api.postits
      .destroy(this.currentPostit.id, this.currentPostit)
      .subscribe(
        (data) => {
          this.getPostits();
          this.editingPostit = false;
          this.hideDeletePostit();
          const msg = this.getValue("stratbox:postit-deleted");
          this.showMsg(msg);
        }, (err) => { console.log(err); }
      )
    target.remove();
  }

  fileChange(event) {
    let file = event.srcElement.files[0];
    let fd = new FormData();

    fd.append('attachment', file, file.name);
    this.sendingFile = true;
    this._api.postits
      .partialUpdate(this.currentPostit.id, fd, {}, true)
      .subscribe(
        (data: IPostit) => {
          this.sendingFile = false;
          this.currentPostit = data;
        }, (err: any) => {
          console.log(err);
        })
  }

  saveContent(callback?: any) {
    if (this.userIsPostitAuthor || this.userIsProjectBoardAuthor) {
      this.updatePostit();
      if (callback) {
        callback();
      }
    }
  }

  closePostitEdit() {
    if (this.canCloseEdit) {
      this.isEditingPostit = false;
      this.saveContent();
      let ref = document.getElementsByClassName('edit-post')[0] as HTMLElement;
      ref.classList.remove('color-mini-toolbar-opened');
      this.currentPostit.nb_likes = this.postitLikes.length;
      this.currentPostit.nb_comments = this.postitComments.length;
      this.editingPostit = false;
      this.isPostitLiked = false;
      this.postitCleared = false;
    }
  }

  stratboxCanAccessZenbaia() {
    this._api.accessZenbaia.retrieve(this.projectBoardId).subscribe(
      (data) => {
        this.zenbaiaAccess = data.can_access;
      },
      (err) => { console.log(err) }
    )
    
  }

  generateZenbaia() {
    this.zenbaiaLoading = true;
    this._api.zenbaia.retrieve(this.projectBoardId).subscribe(
      (data) => {
        // Remplacer les titres #, ## ou ### par du texte en gras
        let content = data.summary.replace(/^#{1,3}\s+(.+)$/gm, '<strong>$1</strong>');
        this.zenbaiaContent = content.replace(/\n/g, '<br>');
        this.zenbaiaLoading = false;
      },
      (err) => { console.log(err) });
  }


  showZenbaiaPostit() {
    this.showZenbaiaChoice = true;
  }
  hideZenbaiaPostit() {
    this.showZenbaiaChoice = false;
  }

  hideDeletePostit() {
    this.showPostitChoice = false;
  }

  showDeletePostit() {
    this.showPostitChoice = true;
  }

  stopEvent(event: MouseEvent) {
    event.stopPropagation();
  }

  clearPostitText() {
    console.log(this.currentPostit.content, this.postitBaseContent, this.postitCleared);
    if (this.currentPostit.content == this.postitBaseContent && !this.postitCleared) {
      this.currentPostit.content = '';
      // this.postitText.nativeElement.innerText = '';
      this.postitCleared = true;
    }
  }

  openPostitModal(postitHtmlElement, postitJSElement) {
    this.openedPostit = postitHtmlElement;
    this.currentPostit = postitJSElement;
    postitHtmlElement.style.zIndex = '10000';

    let relativeTopPosition = postitHtmlElement.getBoundingClientRect().top - this.spaceBoundings.top;
    let scrollableHeight = this.spaceBoundings.bottom - this.spaceBoundings.top;
    let topPercent = relativeTopPosition / scrollableHeight * 100;
    if (topPercent <= 40) {
      postitHtmlElement.classList.add('toolbar-inverted')  //the toolbar must appear under the postit if the postit is located in the first 40% of the screen
    }
    postitHtmlElement.classList.add('toolbar-opened')
  }

  focusPostit(event: MouseEvent, postit) {
    event.stopPropagation();
    this.removeToolbar()
    this.deactivateTimeout()
    let target = event.target as HTMLElement;
    if (!this.isMoving) {
      this.openPostitModal(target, postit);
    }
    this.getPostitLikes()
  }

  showColorToolbar(event: MouseEvent) {
    event.stopPropagation();
    this.openedPostit.classList.add('color-toolbar-opened')
  }

  showColorMiniToolbar(event: MouseEvent) {
    event.stopPropagation();
    let ref = document.getElementsByClassName('edit-post')[0] as HTMLElement
    ref.classList.add('color-mini-toolbar-opened')
  }


  //////////////////////
  // Comments & Likes //
  //////////////////////

  getPostitComments() {
    this._api.postitComments
      .list({
        postit: this.currentPostit.id,
        limit: 150,
      })
      .subscribe(
        (data) => {
          this.postitComments = data.results;
          let ids = [];
          this.postitCommentsNames = [];
          data.results.map((val) => {
            if (!(ids.indexOf(val.author) > -1)) {
              this.postitCommentsNames.push(val.author_obj.full_name);
              ids.push(val.author);
            }
          })
        },
        (err) => { console.log(err) });
  }

  getRightPlaceholder(nbComments) {
    const add_comment = this.getValue("stratbox:add-comment");
    const answer = this.getValue("stratbox:answer");

    let placeholder = (nbComments === 0) ? add_comment : answer
    return placeholder
  }

  updateColor(color) {
    this.currentPostit.color = color;
  }

  editComment(postit) {
    this.isCommentEditing = true;
    this.newComment.comment = postit.comment;
    this.currentComment = postit;
  }


  confirmEditComment(event) {
    this._api.postitComments
      .partialUpdate(this.currentComment.id, { comment: this.newComment.comment })
      .subscribe(
        (data: IPostitComment) => {
          this.getPostitComments();
          this.newComment.comment = '';
          this.isCommentEditing = false;
        },
        (err) => { console.log(err); }
      )
  }

  addComment() {
    this.newComment.postit = this.currentPostit.id;
    this._api.postitComments
      .create(this.newComment)
      .subscribe(
        (data: IPostitComment) => {
          this.getPostitComments();
          this.newComment.comment = '';
        },
        (err) => { console.log(err); }
      )
  }

  cancelComment() {
    this.newComment.comment = '';
  }

  deleteComment() {
    this._api.postitComments
      .destroy(this.currentComment.id, this.currentComment)
      .subscribe(
        (data) => {
          this.getPostitComments();
          this.showCommentChoice = false;
        }, (err) => { console.log(err); }
      )
  }

  hideDeleteCommentChoice() {
    this.showCommentChoice = false;
  }

  showDeleteCommentChoice(comment: IPostitComment) {
    this.currentComment = comment;
    this.showCommentChoice = true;
  }

  getPostitLikes() {
    this._api.postitLikes
      .list({
        postit: this.currentPostit.id,
        limit: 150,
      })
      .subscribe(
        (data) => {
          this.postitLikes = data.results;
          this.currentPostit.nb_likes = data.results.length;
          this.checkIfPostitLiked();
        },
        (err) => { console.log(err) });
  }

  checkIfPostitLiked() {
    this.postitLikes.map((p) => {
      if (p.author_obj.id === this.user.id) {
        this.isPostitLiked = true;
        this.postitLiked = p;
      }
    })
  }

  addLike() {
    this.newLike.postit = this.currentPostit.id;

    if (this.isPostitLiked) {
      this.isPostitLiked = false;
      this._api.postitLikes
        .destroy(this.postitLiked.id, this.postitLiked)
        .subscribe(
          (data) => {
            this.getPostitLikes();
          }, (err) => { console.log(err); }
        )
    } else {
      this._api.postitLikes
        .create(this.newLike)
        .subscribe(
          (data) => {
            this.getPostitLikes();
          }, (err) => { console.log(err); }
        )
    }
  }

  attachAuthorInfo(postits) {
    // overriding postits with a writtenByMe attribute which specifies if i'm the postit owner ( needed for permissions )
    for (let postit of postits) {
      postit.writtenByMe = (postit.author === this.user.id);
    }
    return postits
  }


  //////////////////////
  // Spaces Utilities //
  //////////////////////

  getX(x: number) {
    let X = ((x - this.spaceBoundings.left) / this.spaceBoundings.width * 100);
    return X;
  }

  getInsetX(x: number) {
    let X = this.getX(this.spaceBoundings.x + x);
    return X;
  }

  getY(y: number) {
    let Y = ((y - this.spaceBoundings.top) / this.spaceBoundings.height * 100);
    return Y;
  }

  getInsetY(y: number) {
    let Y = this.getY(this.spaceBoundings.y + y);
    return Y;
  }

  getDelta(lastEv, newEv) {
    let delta = newEv - lastEv;
    return delta;
  }


  ///////////////////
  // Postit Events //
  ///////////////////

  movePostit(event: MouseEvent, p: IPostit) {
    this.deactivateTimeout();
    event.stopPropagation();

    this.getSpaceBoundings();

    this.lastEvent = event;
    this.currentPostit = p;
    this.mouseDown = true;
    this.currentElem = event.srcElement;
  }

  moveFinished(event, p) {
    // Saving needed after each event ( move or resize )
    this.getPostitAuthor()
    setTimeout(() => {
      this.saveContent();
    }, 300)
  }

  resizePostit(event: MouseEvent, p: IPostit, leftSide = false) {
    this.resizeFromLeft = leftSide;
    event.stopPropagation();
    this.isResizing = true;
    this.currentPostit = p;
  }



  onMousemove(event: MouseEvent) {
    if (this.currentElem) {
      let currentPos = this.currentElem.getBoundingClientRect();
      if (this.mouseDown) {   //postit movement behavior

        if (this.userIsProjectBoardAuthor || this.currentPostit.writtenByMe) { // superuser can move every post it, others can only move their postits
          this.hasMoved = true;
          this.isMoving = true;


          let delta = {
            left: this.getDelta(this.lastEvent.clientX, event.clientX),
            top: this.getDelta(this.lastEvent.clientY, event.clientY)
          };

          if ((currentPos.left + delta.left) < this.spaceBoundings.left + 5) {
            // this.currentPostit.left = this.getInsetX(this.halfPostit);
          } else if ((currentPos.right + delta.left) > this.spaceBoundings.right - 20) {
            // this.currentPostit.left = this.getInsetX(this.spaceBoundings.width - this.halfPostit);
          } else {
            this.currentPostit.left = this.currentPostit.left + this.getInsetX(delta.left);
          }

          if ((currentPos.top + delta.top) < this.spaceBoundings.top + 5) {
            // this.currentPostit.top = this.getInsetY(this.halfPostit);
          } else if ((currentPos.bottom + delta.top) > this.spaceBoundings.bottom - 5) {
            // this.currentPostit.top = this.getInsetY(this.spaceBoundings.height - this.halfPostit);
          } else {
            this.currentPostit.top = this.currentPostit.top + this.getInsetY(delta.top);
          }

          this.lastEvent = event;
        } else {

          const msg = this.getValue("stratbox:no-permissions")
          this.showMsg(msg)
        }
      }
      if (this.isResizing) { //postit resizing behavior
        // when the resizing is initiated from the left of the postit, a translation towards the left ( ie negative ) must induce an increase instead 
        // when the resizing is initiated from the left of the postit, a translation towards the left ( ie negative ) must induce an increase instead 
        // when the resizing is initiated from the left of the postit, a translation towards the left ( ie negative ) must induce an increase instead 
        // when the resizing is initiated from the left of the postit, a translation towards the left ( ie negative ) must induce an increase instead 
        // when the resizing is initiated from the left of the postit, a translation towards the left ( ie negative ) must induce an increase instead 
        if (this.userIsProjectBoardAuthor || this.currentPostit.writtenByMe) { // superuser can resize every post it, others can only resize their postits
          if (this.resizeFromLeft) {
            if (event.movementX < 0) { // ie we must increase post it size
              if (this.isResizingCorrect(currentPos)) {
                this.currentPostit.width = this.currentPostit.width - event.movementX;
              }
            } else {
              this.currentPostit.width = Math.max(80, this.currentPostit.width - event.movementX);
            }
          } else {
            if (event.movementX < 0) { // we must decrease post it size
              this.currentPostit.width = Math.max(80, this.currentPostit.width + event.movementX);
            } else {
              if (this.isResizingCorrect(currentPos)) {
                this.currentPostit.width = this.currentPostit.width + event.movementX;
              }
            }
          }
        } else {
          const msg = this.getValue("stratbox:no-permissions")
          this.showMsg(msg)
        }
      }
    }
  }

  isResizingCorrect(position) {
    // prevents any resizing from putting the postit outside of the scrollable zone
    if (position.left >= this.spaceBoundings.left + 20) {
      if (position.right <= this.spaceBoundings.right - 20) {
        if (position.top >= this.spaceBoundings.top + 20) {
          if (position.bottom <= this.spaceBoundings.bottom - 20) {
            return true
          }
        }
      }
    }
    return false
  }


  onMouseup(event: MouseEvent) {
    setTimeout(() => {
      this.mouseDown = false;
      this.isResizing = false;
      this.isMoving = false;
    }, 100)
  }

  /////////////////
  // Exportation //
  /////////////////

  sharePostit(event: MouseEvent) {
    event.stopPropagation();

    this.zeebraSharing = true;
    this.saveContent();

    // html2canvas( this.postit.nativeElement )
    //   .then((data) => {
    //     this.canvas = data.toDataURL('image/png');
    //   })
    //   .catch(err => {
    //     console.log("error canvas", err);
    //   });
  }

  sendPostit(form: NgForm, labelForm: NgForm) {
    const msg = this.getValue("stratbox:creation-in-progress")
    this.showMsg(msg, 4000);
    let postitForm: any = {};
    let labels = [];
    this.sendingPostIt = true;
    postitForm = form.value;
    postitForm.body = this.currentPostit.details;
    postitForm.post_type = 1;
    postitForm.is_exercise = false;

    this.labels.map((l, index) => {
      let id = parseInt(labelForm.value[l.id]);
      if (id) {
        labels.push(id);
      }
    })

    postitForm.labelitems = labels;
    postitForm.postit = this.currentPostit.id

    this._api.posts
      .create(postitForm)
      .subscribe(
        (data) => {
          this.zeebraSharing = false;
          this.sendingPostIt = false;
          const msg = this.getValue("stratbox:creation-success")
          this.showMsg(msg);
          this.closePostitEdit();
          form.reset();
          this.categories = [];
          this.community = '';
          this.labels = [];
          // if (this.postitComments) {
          //   this.sendPostitComment(data.id);
          // }
        }, (err) => {
          this.sendingPostIt = false;
          if (err.category) {
            const msg = this.getValue("stratbox:category-null")
            this.showMsg(msg);
          }

        })
  }

  // async sendPostitComment(postId) {
  //   for (const comment of this.postitComments) {
  //     await new Promise((resolve) => {
  //       this._api.comments
  //         .create({ body: comment.comment, post: postId, stratbox_author: comment['author'] })
  //         .subscribe(
  //           (data) => {
  //             resolve(true)
  //           })
  //     })
  //   }
  // }

  hideShare() {
    this.zeebraSharing = false;
    this.canvas = '';
  }

  getLabelAndCategories(event) {
    console.log('getLabelAndCategories')
    this.getCategories();
    this.getLabels();
  }

  getCategories() {
    this._api.categories
      .list({
        community_id: this.community,
        limit: 1000,
        page_size: 1000
      })
      .subscribe((data) => {
        this.categories = data.filter(c => c.is_archived === false);
      })
  }

  getLabels() {
    this._api.labels
      .list({
        community: this.community,
        limit: 1000,
        page_size: 1000
      })
      .subscribe((data) => {
        this.labels = data;
      })
  }


  ////////////////
  // Left Panel //
  ////////////////

  toggleEditMode() {
    this.editMode = !this.editMode;
  }

  toggleInviteMode() {
    this.inviteMode = !this.inviteMode;
  }

  toggleFS() {
    this.fsMode = !this.fsMode;
  }

  toggleFlap() {
    this.flapToggled = !this.flapToggled;
  }

  export() {
    this.loading = true
    this._api.pdfs.create({}, {}, false, this.projectBoardId + '/export').subscribe((data) => {
      window.open(data.url, '_blank')
      this.loading = false
    })
  }


  //////////////////
  //     Zoom     //
  //////////////////

  mouseWheelHandler(e) {
    var board = document.getElementsByClassName('js-zoom')[0] as HTMLElement;
    var boardWrapper = document.getElementsByClassName('board-wrapper')[0] as HTMLElement;
    var e = window.event || e; // old IE support

    let mouseX = e.pageX;
    let mouseY = e.pageY;

    let rect = board.getBoundingClientRect();
    let rectWrapper = boardWrapper.getBoundingClientRect();

    var delta = Math.max(-1, Math.min(1, (e.wheelDelta || -e.detail)));

    this.scale += (delta / 10);
    if (this.scale < 1) {
      this.scale = 1
    }
    if (this.scale > 4) {
      this.scale = 4
    }

    // indicates where should the viewport be regarding of where did the user scrolled
    let viewportPositionX = Math.round(Math.max(0, (mouseX - rect.left) - (rectWrapper.width / 2)))
    let viewportPositionY = Math.round(Math.max(0, (mouseY - rect.top) - (rectWrapper.height / 2)));

    if (e.deltaY > 0) {
      this.zoomInWheel(viewportPositionX, viewportPositionY);
    } else if (e.deltaY < 0) {
      this.zoomOutWheel(); // no need to move the viewport when zooming out
    }
  }


  mouseHandlerInit() {
    var board = document.getElementsByClassName('js-zoom')[0] as HTMLElement;

    board.addEventListener('wheel', (e) => { // prevent default
      e.preventDefault();
    });

    // we throttle the wheel events, so that only one is fired every 400ms
    const wheels = fromEvent(board, 'wheel');
    const result = wheels.pipe(
      throttle(ev => interval(400)),
    );
    const subscribe = result.subscribe((val) => {
      this.mouseWheelHandler(val);
    });
  }

  dragHandlerInit() {
    let board = document.getElementsByClassName("board-wrapper")[0] as HTMLElement;
    let pos = { top: 0, left: 0, x: 0, y: 0 };

    board.addEventListener('mousedown', (event) => {
      pos = {
        // The current scroll
        left: board.scrollLeft,
        top: board.scrollTop,
        // Get the current mouse position
        x: event.clientX,
        y: event.clientY,
      };
      board.style.cursor = 'grabbing';
      board.style.userSelect = 'none';
    });

    board.addEventListener('mousemove', (event) => {
      // only do this when the primary mouse button is pressed (event.buttons = 1) but not when moving or resizing a postit
      if (event.buttons && !this.isMoving && !this.isResizing) {
        const dx = event.clientX - pos.x;
        const dy = event.clientY - pos.y;

        // Scroll the element
        board.scrollTop = pos.top - dy;
        board.scrollLeft = pos.left - dx;
      }
    });
    board.addEventListener('mouseup', () => {
      board.style.cursor = 'grab';
      board.style.removeProperty('user-select');
    });
  }

  zoomInWheel(viewportPositionX, viewportPositionY) {
    if (this.zoomLevel != this.zoomLevelMax) {
      let deltaZoom = (this.zoomLevel + 10 > 200) ? 200 - this.zoomLevel : 10 // zoom by 10% if possible, else only by the remaining
      this.zoomLevel += deltaZoom
      let board = document.getElementsByClassName("js-zoom")[0] as HTMLElement;
      let boardWrapper = document.getElementsByClassName("board-wrapper")[0] as HTMLElement;
      boardWrapper.scrollTo({
        top: viewportPositionY,
        left: viewportPositionX
      })
      let oldWidth = board.offsetWidth;
      let oldHeight = board.offsetHeight;
      let newWidth = oldWidth + (this.refWidth * (deltaZoom / 100));
      let newHeight = oldHeight + (this.refHeight * (deltaZoom / 100));
      board.style.width = newWidth.toString() + 'px';
      board.style.height = newHeight.toString() + 'px';
    }
  }

  zoomOutWheel() {
    if (this.zoomLevel != this.zoomLevelMin) {
      let deltaZoom = (this.zoomLevel - 10 < 100) ? this.zoomLevel - 100 : 10 // dezoom by 10% if possible, else only by the remaining
      this.zoomLevel -= deltaZoom
      let board = document.getElementsByClassName("js-zoom")[0] as HTMLElement;
      let oldWidth = board.offsetWidth;
      let oldHeight = board.offsetHeight;
      let newWidth = oldWidth - (this.refWidth * (deltaZoom / 100));
      let newHeight = oldHeight - (this.refHeight * (deltaZoom / 100));
      board.style.width = newWidth.toString() + 'px';
      board.style.height = newHeight.toString() + 'px';
    }
  }


  zoomIn() {
    if (this.zoomLevel != this.zoomLevelMax) {
      let deltaZoom = (this.zoomLevel + 25 > 200) ? 200 - this.zoomLevel : 25 // zoom by 25% if possible, else only by the remaining
      this.zoomLevel += deltaZoom;
      let board = document.getElementsByClassName("js-zoom")[0] as HTMLElement;
      let oldWidth = board.offsetWidth;
      let oldHeight = board.offsetHeight;
      let newWidth = oldWidth + (this.refWidth * (deltaZoom / 100));
      let newHeight = oldHeight + (this.refHeight * (deltaZoom / 100));
      board.style.width = newWidth.toString() + 'px';
      board.style.height = newHeight.toString() + 'px';
      let deltaX = (newWidth - oldWidth) / 2
      let deltaY = (newHeight - oldHeight) / 2
      this.moveBoardViewport(deltaX, deltaY);
    }
  }

  zoomOut() {
    if (this.zoomLevel != this.zoomLevelMin) {
      let deltaZoom = (this.zoomLevel - 25 < 100) ? this.zoomLevel - 100 : 25 // dezoom by 25% if possible, else only by the remaining
      this.zoomLevel -= deltaZoom
      let board = document.getElementsByClassName("js-zoom")[0] as HTMLElement;
      let oldWidth = board.offsetWidth;
      let oldHeight = board.offsetHeight;
      let newWidth = oldWidth - (this.refWidth * (deltaZoom / 100));
      let newHeight = oldHeight - (this.refHeight * (deltaZoom / 100));
      board.style.width = newWidth.toString() + 'px';
      board.style.height = newHeight.toString() + 'px';
      let deltaX = (newWidth - oldWidth) / 2
      let deltaY = (newHeight - oldHeight) / 2
      this.moveBoardViewport(deltaX, deltaY);
    }
  }

  moveBoardViewport(deltaX, deltaY) {
    let boardWrapper = document.getElementsByClassName("board-wrapper")[0] as HTMLElement;
    boardWrapper.scrollBy({
      top: deltaY,
      left: deltaX
    });
  }
}



// WEBPACK FOOTER //
// /mnt/disk/stratbox.dev/src/app/board/board.component.ts